// removed by extract-text-webpack-plugin
module.exports = {"resultCard":"resultCard__3r2g3","details":"details__1wTOw","title":"title__KXTrj","date":"date__1McNk","result":"result__3v8Sw","divider":"divider__GLpza","secondary":"secondary__-gOBO","block":"block__19gYK","content":"content__BC2Pa","button":"button__3VP4W","hidden":"hidden__1tE4N"};


//////////////////
// WEBPACK FOOTER
// ./components/search/searchResultCard/style.css
// module id = EXAZ
// module chunks = 14